import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import Swal from 'sweetalert2';
import TableContainer from '@mui/material/TableContainer';
import { TablePagination } from '@material-ui/core';
import FormDialog from './FormDialog';
import { Skeleton } from '@mui/material';
import { axiosClient } from '../AxiosClient';



const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    color: '#FFFFFF',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    }
});

const useStyles = makeStyles((theme) => ({
    mora: {
        color: '#D10909',
    },
    celda: {
        padding: '300px'
    },
    dialogo: {
        width: '800px'
    }
}));


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

var formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
});



export default function NovedadesSiigo() {
    const [data, setData] = useState();
    const [page, setPage] = useState(0);
    const [infos, setInfos] = useState(0);
    const [currentDate, setCurrentDate] = useState("");
    const [checkboxes, setCheckboxes] = useState([]);
    const [dataClient, setDataClient] = useState([]);
    const [client, setClient] = useState();
    const [textClient, setTextClient] = useState();
    const [pageClient, setPageclient] = useState(0);
    const [updateComment, setUpdateComment] = useState("")
    const [quotas, setQuotas] = useState("")

  


    const classes = useStyles();

    const dateFormater = (dateToFormat) => {
        if (dateToFormat && dateToFormat !== '') {
            try {
                const dateObj = new Date(dateToFormat);
                
                // Formatear fecha (DD-MM-YYYY)
                const day = String(dateObj.getDate()).padStart(2, '0');
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                const year = dateObj.getFullYear();
                
                // Formatear hora (HH:MM:SS)
                const hours = String(dateObj.getHours()).padStart(2, '0');
                const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                const seconds = String(dateObj.getSeconds()).padStart(2, '0');
                
                return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
            } catch (e) {
                console.error("Error formateando fecha:", e);
                return "Fecha inválida";
            }
        }
        return "Fecha inválida";
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setPageclient(newPage)
        console.log("search:"+textClient)
        if(textClient != undefined && textClient != "") {
            axiosClient.get(`/v1/quotas/list/client/${client}`, {
                params: {
                    sort: 'createdDate,desc',
                    size: 20,
                    page: newPage
                }
            })
            .then(response => {
                console.log(response.data.content);
                setData(response.data.content);
                setInfos(response.data);
            })
            .catch(error => {
                console.log('Error: ' + error.message);
            });
        } else {
            axiosClient.get('/v1/failed-eliminated-quota', {
                params: {
                    sort: 'payDate,asc',
                    size: 20,
                    page: newPage,
                    search: 'is_corrected:FALSE'
                }
            })
            .then(response => {
                setData(response.data.content);
                setInfos(response.data);
            })
            .catch(error => {
                console.log('Bad petition: ' + error.message);
            });
        }
    }

    const handleQuotaFix = (quotaUuid) => {
        Swal.fire({
            title: '¿Estás seguro que deseas corregir?',
            text: 'Esta acción marcará la cuota como corregida',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#161e55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                // Petición PATCH para marcar como corregida
                axiosClient.patch(`/v1/failed-eliminated-quota/${quotaUuid}`, {
                    isCorrected: true  // Solo actualizamos este campo
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    }
                })
                .then(response => {
                    console.log("Cuota corregida:", response.data);
                    setQuotas(quotaUuid);  // Actualiza el estado para refrescar los datos
                    Swal.fire(
                        '¡Corregido!',
                        'La cuota ha sido marcada como corregida',
                        'success'
                    );
                })
                .catch(error => {
                    console.error('Error:', error.message);
                    Swal.fire(
                        'Error',
                        'No se pudo marcar la cuota como corregida',
                        'error'
                    );
                });
            }
        });
    };

   


    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }
        axiosClient.get('/v1/failed-eliminated-quota/findAllWithError', {
            params: {
                size: 20,
                page: page
            }
        })
        .then(response => {
            setData(response.data.content);
            let checks = [];
            response.data.content.forEach(row => {
                checks.push({ id: row.uuid});
            });
            setCheckboxes(checks);
            setInfos(response.data);
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    
        let today = new Date();
        let day = today.getDate();
        let month = today.getMonth() + 1;
        let year = today.getFullYear();
        setCurrentDate(day + "-" + month + "-" + year)
    
    }, [updateComment, quotas]);
    

    useEffect(() => {
        axiosClient.get(`/v1/clients`, {
            params: {
                search: `fullName:'*${textClient}*'`
            }
        })
        .then(response => {
            if (response.data.content.length !== 0) {
                setDataClient(response.data.content);
            }
        })
        .catch(error => {
            console.log('Error: ' + error.message);
        });
    }, [textClient])


     return (
            <React.Fragment>
                {/* <Box sx={{ display: 'flex' }}> */}
                    <CssBaseline />
                  
                    <br /><br />
                    <Toolbar />
                    <Box sx={{ width: '100%'}}>
                        <Stack spacing={2}>
                            <Item>.</Item>
                            <Item></Item>
                            {/* first line */}
                            <Grid container spacing={2} width={'100%'}>
                                <Box sx={{width: '100%', margin: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <Grid item>
                                        <h1>Novedades en proceso de eliminación de cuota en siigo</h1>
                                    </Grid>                                  
                                </Box>
                            </Grid>
                            {/* second line */}
                            <Grid container spacing={2} sx={{width: '100%'}}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">ID credito</TableCell>
                                                <TableCell align="center">Numero de cuota</TableCell>
                                                <TableCell align="center">Cliente</TableCell>
                                                <TableCell align="center">Valor pagado</TableCell>
                                                <TableCell align="center">Comentarios</TableCell>
                                                <TableCell align="center">Fecha de error reportado</TableCell>
                                                <TableCell align="center">Error en contabilidad inversa</TableCell>
                                                <TableCell align="center">Error en generacion nota credito</TableCell>
                                                <TableCell align="center">Error reportado</TableCell>
                                                <TableCell align="center"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data ? data.map((row) => (
                                                <TableRow key={row.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.celda} align="center">
                                                    {row?.oldIdCredit}
                                                    </TableCell>
                                                    <TableCell className={classes.celda} align="center">
                                                    {row?.quotaNumber}
                                                    </TableCell>
                                                    <TableCell align="center" >
                                                        {row?.client?.name} {row?.client?.lastName}
                                                        <br />
                                                        {row?.client?.documentType} {row?.client?.documentNumber} <br />
                                                        {row?.client?.cellphone}
                                                    </TableCell>
                                                    <TableCell align="center">{formatter.format(row.paidValue)}</TableCell>
                                                    <TableCell align="center">
                                                        <FormDialog novedadSiigoUuid={row.uuid} novedadSiigoComment={row.comments} className={classes.dialogo} setComment={setUpdateComment}></FormDialog>
                                                    </TableCell>
                                                    <TableCell align="center">{dateFormater(row.createdDate)} </TableCell>
                                                    <TableCell align='center'>
                                                    <Checkbox checked={Boolean(row.errorInReverseAccounting)} disabled />
                                                    </TableCell>  
                                                    <TableCell align='center'>                                                
                                                    <Checkbox checked={Boolean(row.errorInCreditNote)} disabled />
                                                    </TableCell>   
                                                    <TableCell align='center'>{row.failDescription}</TableCell>                                                   
                                                    
                                                    
                                                    <TableCell align="center"><ButtonPrincipal  onClick={() => handleQuotaFix(row.uuid)} >Corregir</ButtonPrincipal></TableCell>
                                                </TableRow>
                                            )) : (
                                                <TableRow>
                                                    {[...Array(9)].map((_, index) => (
                                                        <TableCell key={index}>
                                                            <Skeleton variant="rounded" animation="wave" />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            )}                                        
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[infos.size]}
                                        count={infos.totalElements}
                                        rowsPerPage={infos.size}
                                        page={page}
                                        onChangePage={handleChangePage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Stack>
                    </Box>                
            </React.Fragment >
        );
    }